import React from 'react';

export default function Modal({ isOpen, title, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="yk-modal" role="dialog" aria-modal="true">
      <div className="yk-modal__backdrop" onClick={onClose} />
      <div className="yk-modal__panel">
        <div className="yk-modal__accent" />
        <div className="yk-modal__header">
          <div className="yk-modal__title">{title}</div>
          <button type="button" className="yk-icon-btn" onClick={onClose} aria-label="Close modal">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <div className="yk-modal__body">{children}</div>
      </div>
    </div>
  );
}
